import { render } from "./quoting-elec-data.vue?vue&type=template&id=9f1434f0"
import script from "./quoting-elec-data.vue?vue&type=script&lang=js"
export * from "./quoting-elec-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__